import Box from '@eversports/klimt-primitives/legacy/Box'
import SeoLink from '@eversports/klimt-primitives/legacy/SeoLink'
import Stack from '@eversports/klimt-primitives/legacy/Stack'

import { type Tag, VenueProfileTabsPrefix } from '../../../../App.types'
import { TagBadge } from '../../../Discover/Listing/Badge'

interface Props {
  tags: Array<Tag>
  slug: string
}

// once we have the new prices tab, this doesn't have to be external
const TrialOfferTags = ({ tags, slug }: Props) => (
  <Stack component="ul" paddingLeft={0} direction="row" spacing={2}>
    {tags.map(({ name }) => (
      <Box key={name} component="li" display="block">
        <SeoLink encodedTo={btoa(`${VenueProfileTabsPrefix.PRICES}${slug}`)} external type="hidden">
          <TagBadge key={name}>{name}</TagBadge>
        </SeoLink>
      </Box>
    ))}
  </Stack>
)

export default TrialOfferTags
